/**
 * 
 * Hidden Product Pros - ATC
 * 
 */

const form = document.querySelector('form[action$="/cart/add"]')

form.addEventListener('submit', e => {
    e.preventDefault()

    const elements = {
        id: +form.querySelector('[name="id"]')?.value || 0,
        qty: +form.querySelector('[name="quantity"]')?.value || 1,
        profession: form.querySelector('[name="properties[Profession]"]')?.value ?? '',
    }

    let formData 

    if (elements.profession) {
      formData = {
        'items': [
            {
                'id': elements.id,
                'quantity': elements.qty,
                'properties': {
                    'Profession': elements.profession
                  }
            }
        ]
      };
    } else {
      formData = {
        'items': [
            {
                'id': elements.id,
                'quantity': elements.qty
            }
        ]
      };
    }

    

    const freeProduct = form.querySelector('.js-free-product')

    if (freeProduct) {
        formData.items.push({
            'id': +freeProduct.value,
            'quantity': 1
        })
    }

    const button = form.querySelector('.js-sh-submit-btn')
    let btnText = button.value

    button.disabled = true
    button.value = "Adding to cart..."

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        
        // Redirect to cart page
        window.location.href = "/cart"
        
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        button.disabled = false
        button.value = btnText
      })
    
    
})
